import React, { Component } from 'react';
import { connect } from 'react-redux';

class ModalManager extends Component {
  render() {
    /* eslint-disable-next-line */
    return this.props.modals.modals.map((modal, index) => {
      if (modal.opened) {
        const $component = modal.component;
        const modalProps = {
          ...modal.componentProps,
          modalKey: modal.key,
          key: index,
          opened: modal.opened,
        };
        /* eslint-disable-next-line */
        return <$component {...modalProps} />;
      }
    });
  }
}

const mapStateToProps = (state) => ({
  modals: state.modals,
});

export default connect(mapStateToProps)(ModalManager);
